// extracted by mini-css-extract-plugin
export default {"root":"RgO7kk1Sw5UDmn2lI252","arrow--hide":"HW2CCUmfER3HVcNjLXLb","arrow":"MJf7UF1Vw524g7lMkxJy"};